import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AchizitiiComponent } from './achizitii.component';

const routes: Routes = [
    {
        path: ':institution',
        component: AchizitiiComponent
    }
];

@NgModule({
    declarations: [],
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class AchizitiiRoutingModule { }
